import { useQuery } from '@tanstack/react-query';

import { dashboardApi } from '../api/dashboard.adapter';
import type { DashboardPeriod } from '../types/dashboard.types';

export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  summary: () => [...dashboardQueryKeys.all, 'summary'] as const,
  // Period is embedded so weekly/monthly cache independently.
  charts: (period: DashboardPeriod) =>
    [...dashboardQueryKeys.all, 'charts', period] as const,
};

export function useDashboardSummaryQuery() {
  return useQuery({
    queryKey: dashboardQueryKeys.summary(),
    queryFn: () => dashboardApi.getSummary(),
  });
}

export function useDashboardChartsQuery(period: DashboardPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.charts(period),
    queryFn: () => dashboardApi.getCharts(period),
  });
}
